/**
 * NumberField — a `number` attribute (PIM Wave P2, Task 3). Native numeric
 * input (`step="any"`) so `.value` is always a dot-decimal string the backend
 * `Decimal(str(value))` accepts; the raw string round-trips per Q4.
 */
import type { ReactElement } from "react";

import {
  pickOptionalText,
  pickText,
} from "@/features/seller-dashboard/attributes/formSchema";
import {
  ATTR_INPUT_CLASS,
  ATTR_INPUT_ERROR_CLASS,
  FieldShell,
  type AttributeFieldProps,
} from "@/features/seller-dashboard/attributes/fields/FieldShell";

export function NumberField({
  field,
  language,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}: AttributeFieldProps): ReactElement {
  const label = pickText(field.label, language);
  const hint = pickOptionalText(field.hint, language);
  const example = pickOptionalText(field.example, language);
  const controlId = `attr-${field.field_slug}`;
  return (
    <FieldShell
      slug={field.field_slug}
      label={label}
      requirement={field.requirement}
      hint={hint}
      error={error}
    >
      <input
        id={controlId}
        type="number"
        inputMode="decimal"
        step="any"
        aria-label={label}
        aria-invalid={error ? true : undefined}
        placeholder={example}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={[ATTR_INPUT_CLASS, error ? ATTR_INPUT_ERROR_CLASS : ""].join(" ")}
      />
    </FieldShell>
  );
}

export default NumberField;
